import PropTypes from 'prop-types'

import {createVirginMembership} from '../../../api'
import {BusinessConnectionDrawerWithSteps} from '../BusinessConnectionDrawer'

import useFetchPrepopulationData from './hooks/useFetchPrepopulationData'
import {getValidationSchemaForStep} from './schema'
import BusinessInformationStep from './Steps/BusinessInformationStep'
import PersonalInformationStep from './Steps/PersonalInformationStep'
import TermsAndConditionsStep from './Steps/TermsAndConditionsStep'
import TermsAndConditionsModal from './TermsAndConditionsModal'

const VirginBusinessConnectionDrawer = ({
  isOpen,
  onClose,
  partner,
  onSuccess,
}) => {
  const steps = [
    {
      component: BusinessInformationStep,
      title: 'points:connectionDrawer.steps.businessInfo.title',
    },
    {
      component: PersonalInformationStep,
      title: 'points:connectionDrawer.steps.personalInfo.title',
    },
    {
      component: TermsAndConditionsStep,
      title: 'points:connectionDrawer.steps.terms.title',
    },
  ]

  return (
    <BusinessConnectionDrawerWithSteps
      isOpen={isOpen}
      onClose={onClose}
      partner={partner}
      onSuccess={onSuccess}
      apiFunction={createVirginMembership}
      steps={steps}
      useFetchPrepopulationData={useFetchPrepopulationData}
      getValidationSchemaForStep={getValidationSchemaForStep}
      TermsAndConditionsModal={TermsAndConditionsModal}
    />
  )
}

VirginBusinessConnectionDrawer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  partner: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string.isRequired,
    key: PropTypes.string.isRequired,
  }),
  onSuccess: PropTypes.func.isRequired,
}

VirginBusinessConnectionDrawer.defaultProps = {
  partner: null,
}

export default VirginBusinessConnectionDrawer
